import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Col, Container, Row } from 'react-bootstrap';

import SignIn from '../../components/auth/SignIn';
import { Link } from 'react-router-dom';
import signInSideImage from './signInSideImage.png';
import appLogo from '../../assets/img/new/disputelylogonew2-139.svg';

const SignInPage = () => (
  <React.Fragment>
    <Helmet title='Sign In' />
    <style>
      {`
  #showPass .btn:hover {
	color: var(--bs-btn-hover-bg);
	background-color: white;
}
.img-fluid {
  width:580px;
}

.main {
  overflow-y: auto !important;
}
  `}
    </style>
    <Row className='h-100'>
      {/* <Col xl={6} id='leftside' className='d-xl-block d-none d-flex position-relative' style={{ height: '100%' }}>
        <img className='img-fluid me-auto mb-5 mt-auto shadow d-block' alt='Left Side Image' src={signInSideImage} style={{ height: '100%', width: '100%' }} />
        <img
          className='disputely-logo-new-2-1-icon40 mb-5 position-absolute'
          style={{
            top: '28px',
            left: '15%',
          }}
          alt='Dispute.ly'
          src={appLogo}
        />
      </Col> */}
      <Col xl={6} id='leftside' className='d-xl-flex d-none position-relative justify-content-center align-items-center m-auto' style={{ height: '100%', background: '#e1ecfd' }}>
        <img className='img-fluid mx-auto my-auto d-block' alt='Left Side Image' src={signInSideImage} style={{ maxHeight: '80%', width: 'auto' }} />
        <img
          className='disputely-logo-new-2-1-icon40 mb-5 position-absolute'
          style={{
            top: '28px',
            right: '66%',
          }}
          alt='Dispute.ly'
          src={appLogo}
        />
      </Col>

      <Col id='signin' xl={6} lg={4} md={6} xs={9} className='m-auto'>
        <img alt='' src={appLogo} style={{ maxHeight: '80%', width: 'auto' }} className='d-block d-xl-none mx-auto w-35 mb-5' />
        <Col xl={6} className='mx-auto'>
          <h3 className='text-dark-blue mb-4'>Log In</h3>
          <SignIn />
        </Col>
        <Col lg='12'>
          <p className='text-center mt-5'>
            Don't have an account?{' '}
            <Link to='/signup' className='text-decoration-none d-block d-md-inline'>
              Sign Up.
            </Link>
          </p>
        </Col>
      </Col>
    </Row>
  </React.Fragment>
);

export default SignInPage;
